import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setAuthFromResponse } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const r = await api.post("/auth/google", { session_id: sessionId });
        setAuthFromResponse(r.data);
        // Clear hash & redirect by role
        window.history.replaceState(null, "", window.location.pathname);
        const u = r.data.user || {};
        const role = u.role;
        if (role === "admin" || role === "super_admin") navigate("/admin", { replace: true });
        else if (role === "employee") navigate("/employee", { replace: true });
        else if (u.profile_complete === false) navigate("/profile?complete=1", { replace: true });
        else navigate("/dashboard", { replace: true });
      } catch (e) {
        console.error("Auth callback failed", e);
        navigate("/login?error=auth", { replace: true });
      }
    })();
  }, [navigate, setAuthFromResponse]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC]">
      <div className="flex flex-col items-center gap-4" data-testid="auth-callback-loading">
        <Loader2 className="w-10 h-10 text-[#C9A356] animate-spin" />
        <p className="text-[#475569] font-medium">Setting up your account...</p>
      </div>
    </div>
  );
}
